export default "{{ this.response }}\n"